import React from 'react';
import { Input } from 'reactstrap';

export const CommonFormInput = ({
    name,
    onInput,
    placeholder,
    type = "text",
    getFieldProps,
    touched,
    errors,
    className = "form-control",
    autoComplete = "off",
}) => {
    const fieldProps = getFieldProps(name);
    return (
        <>
            {type === "checkbox" ? (
                <Input
                    id={name}
                    name={name}
                    type={type}
                    {...fieldProps}
                    checked={fieldProps.value} // Handle checkbox checked state
                    className={`${touched[name] && errors[name] ? "is-invalid" : ""}`}
                />
            ) : (
                <>
                    <Input
                        onInput={onInput}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                            }
                        }}
                        name={name}
                        autoComplete={autoComplete}
                        type={type}
                        placeholder={placeholder}
                        {...getFieldProps(name, { autoComplete })}
                        className={`${className} ${touched[name] && errors[name] ? "is-invalid" : ""}`}
                    />
                    {touched[name] && errors[name] && (
                        <div className="invalid-feedback">{errors[name]}</div>
                    )}
                </>
            )}



        </>
    );
};



export const CommonSearchInput = ({
    name,
    value,
    onChange,
    onBlur,
    touched,
    errors,
    placeholder,
    searchResults = [],
    onSearchItemClick,
    tooltipId,
    className = "form-control",
    customValue,
    selectedItem,
    onCustomValueChange,
}) => {
    return (
        <div className="w-full position-relative">
            <input
                type="text"
                data-tooltip-id={tooltipId}
                className={`${className} ${touched && errors ? "is-invalid" : ""}`}
                name={name}
                value={selectedItem === "Other" ? customValue : value}
                onChange={(e) => {
                    if (selectedItem === "Other") {
                        onCustomValueChange?.(e.target.value);
                    } else {
                        onChange(e);
                    }
                }}
                onBlur={onBlur}
                placeholder={placeholder}
            />

            {searchResults && searchResults.length > 0 && (
                <div
                    className="position-absolute w-100 bg-white border rounded mt-1"
                    style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto" }}
                >
                    {searchResults.map((item, index) => (
                        <div
                            key={index}
                            className="p-2 cursor-pointer hover:bg-light"
                            onClick={() => onSearchItemClick(item)}
                        >
                            {item}
                        </div>
                    ))}
                </div>
            )}

            {touched && errors && (
                <div className="invalid-feedback">
                    {errors}
                </div>
            )}
        </div>
    );
};

